import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68484c22"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "owner-manager"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "desc" }
const _hoisted_4 = { class: "person-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "phone" }
const _hoisted_9 = {
  key: 0,
  class: "uf-button"
}
const _hoisted_10 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_ctx.list.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_van_swipe, {
            class: "swipe-view",
            autoplay: 5000,
            onChange: _ctx.onChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(item.house_numbers), 1),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(item.true_place), 1)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["onChange"]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list[_ctx.currentIndex]?.user_lists, (i, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "person-item",
                key: idx,
                onClick: ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.VISITOR_OWNER_DETAIL,
              params: { id: i.id },
              query: {
                type: _ctx.list[_ctx.currentIndex]?.house_user_type,
                house_id: _ctx.list[_ctx.currentIndex]?.house_id,
                start: _ctx.list[_ctx.currentIndex]?.date_start,
                end: _ctx.list[_ctx.currentIndex]?.date_end
              }
            })
          )
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(i.name), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(i.house_user_type == '1' ? 'tag1' : 'tag2')
                  }, _toDisplayString(i.house_user_type_name), 3),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(i.mobile), 1)
                ]),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "18",
                  color: "#959FAC"
                })
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        (_ctx.list[_ctx.currentIndex]?.house_user_type == '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_van_button, {
                  block: "",
                  class: "btn",
                  color: "#3d6eeb",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.VISITOR_OWNER_ADD,
              query: {
                house_id: _ctx.list[_ctx.currentIndex]?.house_id,
                start: _ctx.list[_ctx.currentIndex]?.date_start,
                end: _ctx.list[_ctx.currentIndex]?.date_end
              }
            })
          ))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增人员 ")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        class: "custom-image",
        image: require('@/assets/icon_lock.png'),
        description: "暂无数据"
      }, null, 8, ["image"]))
}